export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14207.404cbe12.jpg";